<template>
    <div >
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="">拓客利器</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="">领取列表</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="callcenter">
            <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="精准获客">
                    <a-tab-pane key="2" tab="呼叫统计" force-render>
                    <a-tabs default-active-key="1" class="tel-tj-tab">
                        <a-tab-pane key="1" tab="待我跟进">
                            <div class="top-search record-search" style="">
                                <a-row type="flex">
                                    <a-col><label for="">领取时间：</label></a-col>
                                    <a-col>
                                        <div class="select-date-custom">
                                            <a-input class="search-date" v-model="time" @click="showdate">
                                                <a-tooltip slot="suffix" title="Extra information">
                                                    <div class="date-icon"></div>
                                                </a-tooltip>
                                            </a-input>
                                            <span class="select-date-modal" v-if="dateshow">
                                                <div class="date-modal">
                                                    <div class="time-modal">
                                                        <div class="time-system">
                                                            <div class="select-item" @click="selectdate2(i,item)" :class="{clickdate:i==currentdate}" v-for="(item,i) in datelist2" :key="i">{{item}}</div>
                                                        </div>
                                                        <div class="time-custom">
                                                            <span class="time-system-text">自定义</span>
                                                            <div class="time-select-index-hide">
                                                                <a-date-picker format="YYYY-MM-DD" @change="dateChange2"/>
                                                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </span>
                                        </div>
                                        
                                    </a-col>
                                </a-row>

                                <a-row  type="flex">
                                    <a-col><label for="">跟进状态：</label></a-col>
                                    <a-col>
                                        <a-select style="width: 120px" @change="lxhandleChange2">
                                            <a-select-option value="线索">
                                                线索
                                            </a-select-option>
                                            <a-select-option value="客户">
                                                客户
                                            </a-select-option>
                                            <a-select-option value="商机">
                                                商机
                                            </a-select-option>
                                            <a-select-option value="直呼">
                                                直呼
                                            </a-select-option>
                                            <a-select-option value="回呼">
                                                回呼
                                            </a-select-option>
                                        </a-select>
                                    </a-col>
                                </a-row>

                
                            </div>
                        </a-tab-pane>
                        <!-- <a-tab-pane key="2" tab="按员工" force-render>
                            Content of Tab Pane 2
                        </a-tab-pane> -->
                    </a-tabs>

                    <div class="table-content">
                        <a-spin :spinning="tablespinning">
                            <a-table :pagination="pageshow" :scroll="{ y: tabley}"  :style="{height:tabley+'px'}" :columns="columns" :data-source="data">
                                <span slot="action" slot-scope="text, record">
                                    <span class="actionbtn" @click="toclue(record.id)">转线索</span>
                                </span>
                            </a-table>

                            <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                                <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                                <a-pagination
                                show-size-changer
                                :page-size-options="pageSizeOptions"
                                :default-current="1"
                                :total="pagination.total"
                                :defaultPageSize="10"
                                @change="handleTableChange"
                                @showSizeChange="onShowSizeChange"
                                >
                                    <template slot="buildOptionText" slot-scope="props">
                                        <span>{{ props.value }}条/页</span>
                                    </template>

                                </a-pagination>
                            </div>
                        </a-spin>
                    </div>


                </a-tab-pane>
                </a-tab-pane>
                <a-tab-pane key="2" tab="快商宝">
                     <a-tab-pane key="2" tab="呼叫统计" force-render>
                    <a-tabs default-active-key="1" class="tel-tj-tab">
                        <a-tab-pane key="1" tab="待我跟进">
                            <div class="top-search record-search" style="">
                                <a-row type="flex">
                                    <a-col><label for="">领取时间：</label></a-col>
                                    <a-col>
                                        <div class="select-date-custom">
                                            <a-input class="search-date" v-model="time" @click="showdate">
                                                <a-tooltip slot="suffix" title="Extra information">
                                                    <div class="date-icon"></div>
                                                </a-tooltip>
                                            </a-input>
                                            <span class="select-date-modal" v-if="dateshow">
                                                <div class="date-modal">
                                                    <div class="time-modal">
                                                        <div class="time-system">
                                                            <div class="select-item" @click="selectdate2(i,item)" :class="{clickdate:i==currentdate}" v-for="(item,i) in datelist2" :key="i">{{item}}</div>
                                                        </div>
                                                        <div class="time-custom">
                                                            <span class="time-system-text">自定义</span>
                                                            <div class="time-select-index-hide">
                                                                <a-date-picker format="YYYY-MM-DD" @change="dateChange2"/>
                                                            </div>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </span>
                                        </div>
                                        
                                    </a-col>
                                </a-row>

                                <a-row  type="flex">
                                    <a-col><label for="">跟进状态：</label></a-col>
                                    <a-col>
                                        <a-select style="width: 120px" @change="lxhandleChange2">
                                            <a-select-option value="线索">
                                                线索
                                            </a-select-option>
                                            <a-select-option value="客户">
                                                客户
                                            </a-select-option>
                                            <a-select-option value="商机">
                                                商机
                                            </a-select-option>
                                            <a-select-option value="直呼">
                                                直呼
                                            </a-select-option>
                                            <a-select-option value="回呼">
                                                回呼
                                            </a-select-option>
                                        </a-select>
                                    </a-col>
                                </a-row>

                
                            </div>
                        </a-tab-pane>
                        <!-- <a-tab-pane key="2" tab="按员工" force-render>
                            Content of Tab Pane 2
                        </a-tab-pane> -->
                    </a-tabs>

                    <div class="table-content">
                        <a-spin :spinning="tablespinning">
                            <a-table :pagination="pageshow" :scroll="{ y: tabley}"  :style="{height:tabley+'px'}" :columns="columns" :data-source="data">
                                <span slot="action" slot-scope="text, record">
                                    <span class="actionbtn" @click="toclue(record.id)">转线索</span>
                                </span>
                            </a-table>

                            <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                                <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                                <a-pagination
                                show-size-changer
                                :page-size-options="pageSizeOptions"
                                :default-current="1"
                                :total="pagination.total"
                                :defaultPageSize="10"
                                @change="handleTableChange"
                                @showSizeChange="onShowSizeChange"
                                >
                                    <template slot="buildOptionText" slot-scope="props">
                                        <span>{{ props.value }}条/页</span>
                                    </template>

                                </a-pagination>
                            </div>
                        </a-spin>
                    </div>


                </a-tab-pane>
                </a-tab-pane>
            </a-tabs>
        </div>
    </div>
</template>


<script>
const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: '领取时间',
    key: 'add_time',
    dataIndex: 'add_time',
    scopedSlots: { customRender: 'name' },
  },
//   {
//     title: '领取方式',
//     dataIndex: 'tag',
//     key: 'tag',
//     width: '120px',
//   },
  {
    title: '联系人',
    dataIndex: 'legal',
    key: 'legal',
    width: '150px',
  },
   {
    title: '联系方式',
    dataIndex: 'phone',
    key: 'phone',
    scopedSlots: { customRender: 'mobile_phone' },
  },
  {
    // title: '跟进状态',
    dataIndex: 'morephone',
    key: 'morephone',
    ellipsis: true,
  },
 {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    width:'224px'
  },
];
export default {
    data(){
        return{
            pageSizeOptions:['10','20','30','40','100','200'],
            tablespinning:true,
            size:10,
            currentpage:"",
            pageshow:false,
            totalpage:"",
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            tabley:"",
            pagination:{},
            columns,
            data:[],
            dateshow:false,
            datelist:['今天','昨天','本周','上周','本月','上月'],
            datelist2:['今天','昨天'],
            time:"",
            type:"",
            currentdate:"",
        }
    },
    watch: {
        windowHeight (val) {
            this.tabley=val*0.56
        }
    },
    mounted(){
        window.fullHeight = document.documentElement.clientHeight;
        this.windowHeight = window.fullHeight;  
        this.tabley=this.windowHeight*0.56
        // <!--把window.onresize事件挂在到mounted函数上-->
        window.onresize = () => {
            return (() => {
                window.fullHeight = document.documentElement.clientHeight;
                this.windowHeight = window.fullHeight;  // 高
                this.tabley=this.windowHeight*0.56
                console.log("实时屏幕高度：",this.tabley);
            })()
        };

        this.fetch()
    },
    methods:{
        dateChange2(data,dateString){
        console.log(dateString)
        this.time=dateString
        this.dateshow=false
        this.fetch()
    

        },
        lxhandleChange2(value){
            this.type=value
            this.fetch()
        },
        selectdate2(a,b){
            this.currentdate=a
            this.time=b
            this.dateshow=false
            this.fetch()
        },
        showdate(){
            this.dateshow=!this.dateshow
        },
        // 转线索
        toclue(value){
            this.$axios.post('/api/receivetodata',{
                id: value
            },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },

            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
        fetch(params = {}) {
            this.loading = true;
            // console.log(this.xzlist)
            this.$axios.post('/api/qccreceivelist',{
                limits: this.size,
                page:this.currentpage,
            },{
                headers: {
                    "appid": this.appSet.appid,
                    "appkey": this.appSet.appkey,
                    "token":localStorage.getItem('token'),
                },

            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.count;
                    pagination.pageSize=this.size
                    this.data=res.data.data.lists
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.count/this.size)
                }else if(res.data.code==300){
                    this.$router.push({path: '/'})
                }else if(res.data.code==401){
                    this.$message.warning(res.data.msg);
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/toker/receivelist.vue